import React from 'react';

import { cn } from '../../utils/classname';
import { SocialMedia } from '../social-media-buttons/social-media';
import { Text } from '../text/text';
import { Title } from '../title/title';
import { Translate } from '../translate';
import './share-section.scss';

export const ShareSection: React.FC<{ className: string }> = ({ className }) => {
  const classes = cn('bd-share-section', className);

  return (
    <div className={classes}>
      <img
        className="bd-share-section__img"
        src="https://www.siteground.com/static/2024/en/img/web/sg_birthday/illustration_tshirt.png"
        alt="Giveaway T-Shirt Image"
      />
      <div className="bd-share-section__content">
        <Title level="5" align="center" weight="bold">
          <Translate id="translate.share.section.title" />{' '}
        </Title>
        <Text align="center" fontFamily="roboto">
          <Translate id="translate.share.section.subtitle" />
        </Text>
        <SocialMedia className="bd-share-section__social-icons" intlType="share-card" />
      </div>
    </div>
  );
};
